import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faWrench, faLocationDot, faHouse, faMugHot, faBolt, faGears, faUnlock, faPlaneDeparture, faPlane } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>How I grew up</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2022 - Present"
            iconStyle={{ background: '#333333', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faPlane} />}>
            <h3 className="vertical-timeline-element-title">Technical team lead</h3>
            <h4 className="vertical-timeline-element-title"><FontAwesomeIcon icon={faHouse} className="company" />SPIE / Airbus</h4>
            <h4 className="vertical-timeline-element-subtitle"> <FontAwesomeIcon icon={faLocationDot} className="location" /> Toulouse, France</h4>
            <p>
              Security technical referant
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2019 - 2022"
            iconStyle={{ background: '#333333', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faPlaneDeparture} />}>
            <h3 className="vertical-timeline-element-title">Network & Security Engineer / Technical team lead</h3>
            <h4 className="vertical-timeline-element-title"><FontAwesomeIcon icon={faHouse} className="company" />NTT / Airbus</h4>
            <h4 className="vertical-timeline-element-subtitle"> <FontAwesomeIcon icon={faLocationDot} className="location" /> Toulouse, France</h4>
            <p>
              Security Build & Run / Technical referant
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2018 - 2019"
            iconStyle={{ background: '#333333', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faUnlock} />}>
            <h3 className="vertical-timeline-element-title">Security Engineer</h3>
            <h4 className="vertical-timeline-element-title"><FontAwesomeIcon icon={faHouse} className="company" />Squad / LBP</h4>
            <h4 className="vertical-timeline-element-subtitle"> <FontAwesomeIcon icon={faLocationDot} className="location" /> Toulouse, France</h4>
            <p>
              Security Build & Run
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2016 - 2018"
            iconStyle={{ background: '#333333', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBolt} />}>
            <h3 className="vertical-timeline-element-title">Network & Security Manager</h3>
            <h4 className="vertical-timeline-element-title"><FontAwesomeIcon icon={faHouse} className="company" />Wifak</h4>
            <h4 className="vertical-timeline-element-subtitle"> <FontAwesomeIcon icon={faLocationDot} className="location" /> Tunis, Tunisia</h4>
            <p>
              Network/Security Design & Management
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2015 - 2016"
            iconStyle={{ background: '#333333', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faGears} />}>
            <h3 className="vertical-timeline-element-title">Network & Security Specialist</h3>
            <h4 className="vertical-timeline-element-title"><FontAwesomeIcon icon={faHouse} className="company" />BTK</h4>
            <h4 className="vertical-timeline-element-subtitle"> <FontAwesomeIcon icon={faLocationDot} className="location" /> Tunis, Tunisia</h4>
            <p>
              Network/Security Build & Ops
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2014 - 2015"
            iconStyle={{ background: '#333333', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faMugHot} />}>
            <h3 className="vertical-timeline-element-title">IT Support</h3>
            <h4 className="vertical-timeline-element-title"><FontAwesomeIcon icon={faHouse} className="company" />OMV</h4>
            <h4 className="vertical-timeline-element-subtitle"> <FontAwesomeIcon icon={faLocationDot} className="location" /> Tunis, Tunisia</h4>
            <p>
              IT local support 
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2014 - 2014"
            iconStyle={{ background: '#333333', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faWrench} />}>
            <h3 className="vertical-timeline-element-title">IT Specialist</h3>
            <h4 className="vertical-timeline-element-title"><FontAwesomeIcon icon={faHouse} className="company" />Next-Step</h4>
            <h4 className="vertical-timeline-element-subtitle"><FontAwesomeIcon icon={faLocationDot} className="location" /> Tunis, Tunisia</h4>
            <p>
              Network/Security solution integration
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2014 - 2014"
            iconStyle={{ background: '#333333', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}>
            <h3 className="vertical-timeline-element-title">Security Master degree</h3>
            <h4 className="vertical-timeline-element-title"><FontAwesomeIcon icon={faHouse} className="company" />ISI</h4>
            <h4 className="vertical-timeline-element-subtitle"><FontAwesomeIcon icon={faLocationDot} className="location" /> Tunis, Tunisia</h4>
            <p>
              System, Network and Security courses 
            </p>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;